import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Index from './views/Index.vue'
// import Home from './views/Ecology.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path:'*',
			component:() => import('./views/NotFound.vue'),
		},
		{
			path: '/',
			name: 'index',
			redirect: '/home',
			component: Index
		},
		{
			path: '/home',
			name: 'index',
			component: Index
		},		
		// {
		// 	path: '/',
		// 	name: 'home',
		// 	component: Home
		// },
		{
			path: '/ecology',
			name: 'ecology',
			component: () => import('./views/Ecology.vue')
		},
		{
			path: '/technology',
			name: 'technology',
			component: () => import('./views/Technology.vue')
		},
		{
			path: '/solution',
			component: () => import('./views/Solution.vue'),
			children:[
				{
					path: '',
					redirect:'/solution/ctiy',
					component: () => import('./views/SolutionCity.vue')
				},
				{
					path: 'ctiy',
					component: () => import('./views/SolutionCity.vue')
				},
				{
					path: 'country',
					component: () => import('./views/SolutionCountry.vue'),
					children:[
						{
							path: 'solutioncountrynumber',
							component: () => import('./views/SolutionCountryNumber.vue')
						},
						{
							path: 'solutioncountryoperation',
							component: () => import('./views/SolutionCountryOperation.vue')
						}
					]
				},
				// {
				// 	path: '',
				// 	component: () => import('./views/SolutionTour.vue')
				// },
				{
					path: 'solutionCard',
					component: () => import('./views/SolutionCard.vue')
				},
				{
					path: 'solutiontrade',
					component: () => import('./views/SolutionTrade.vue')
				}
			]
		},
		{
			path: '/news',
			component: () => import('./views/News.vue'),
			children: [
				{ 
					path: '', 
					component: () => import('./views/List.vue')
				},
				{
					path: 'list',
					component: () => import('./views/List.vue')
				},
				{
					path: 'detail',
					component: () => import('./views/Detail.vue')
				}
			]
		},
		{
			path: '/about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
			children: [
				{ 
					path: '', 
					component: () => import('./views/Cloudcode.vue')
				},
				{
					path: 'cloudcode',
					component: () => import('./views/Cloudcode.vue')
				},
				{
					path: 'certification',
					component: () => import('./views/Certification.vue')
				},
				{
					path: 'platform',
					component: () => import('./views/Platform.vue')
				}
			]
		},
		{
			path: '/contact',
			component: () => import('./views/Contact.vue'),
			children: [
				{ 
					path: '', 
					component: () => import('./views/ContactUs.vue')
				},
				{
					path: 'us', 
					component: () => import('./views/ContactUs.vue')
				},
				{
					path: 'recruit',
					component: () => import('./views/Recruit.vue')
				}
			]
		},
		{
			path: '/recruit',
			name: 'recruit',
			component: () => import('./views/Recruit.vue')
		}
	]
})
